import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:{

  },
  transactionExtraData:{

  },
  pdfUrl:''

}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_TRANSACTION (state, isLoading){
    state.status.loading = isLoading
  },

  SET_TRANSACTION (state, data){
    state.items = data
  },
  SET_TRANSACTION_EXTRA_DATA (state, data){
    state.transactionExtraData = data
  },
  SET_TRANSACTION_PDF_URL (state, data){
    state.pdfUrl = data
  }
}

//async methods  store.dispatch('increment')
const actions = {


  loadTransactionStore ({state, commit}, [page,code]) {

    commit('LOADING_TRANSACTION', true);

    return api.get('transaction?page='+page+'&code='+code)
      .then(function (response) {

        commit('SET_TRANSACTION_EXTRA_DATA', response.data.transaction)
        commit('SET_TRANSACTION', response.data.transaction.data)

        commit('LOADING_TRANSACTION', false);
      })
      .catch(function (error) {
        commit('LOADING_TRANSACTION', false);

      });
  },
  
  getTransactionPdfUrl ({state, commit}, trxId) {

    commit('LOADING_TRANSACTION', true);

    return api.get('transaction/'+trxId+'/invoice')
      .then(function (response) {
        commit('SET_TRANSACTION_PDF_URL', response.data.url)
      
        commit('LOADING_TRANSACTION', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_TRANSACTION', false);
        return Promise.reject(error);

      });
  }


}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/TransactionStore.js